import React from "react";
import MuiLink from "@mui/material/Link";
import clsx from "clsx";

import { useLinkStyles, useStyles } from "./Link.styles";
import { LinkProps } from "./Link.types";

function Link(props: LinkProps): JSX.Element {
  const {
    children,
    component,
    disabled,
    icon: iconProp,
    iconClassName,
    to,
    ...other
  } = props;

  const linkClasses = useLinkStyles(props);

  const classes = useStyles();

  let icon = null;

  if (React.isValidElement(iconProp)) {
    icon = React.cloneElement(
      iconProp as React.ReactElement<{ className?: string }>,
      {
        className: clsx(classes.icon, iconClassName),
      }
    );
  }

  return (
    <MuiLink
      {...other}
      classes={linkClasses}
      component={component}
      to={to}
      disabled={disabled}
    >
      {children}
      {icon}
    </MuiLink>
  );
}

export default Link;
